import { Switch, SwitchChangeEvent } from '@progress/kendo-react-inputs';

interface IKendoSwitchProps {
    checked: boolean
    onChange: (checked: boolean) => void
    disabled?: boolean
    size?: 'small' | 'medium' | 'large'
}

const KendoSwitch = ({ checked, onChange, disabled = false, size = 'medium' }: IKendoSwitchProps) => {
    return (
      <Switch
        defaultChecked={checked}
        disabled={disabled}
        onChange={(event: SwitchChangeEvent) => onChange(event.value)}
        onLabel=''
        offLabel=''
        size={size}
      />
    )
};

export default KendoSwitch;
